import { createSlice } from "@reduxjs/toolkit";
import { CropInformationDefaultDataSetDisease } from "../data_model/diseaseInfoModel/post_disease_information_model";

export const update_Disease_Info = createSlice({
  name: "update_disease_information",
  initialState: {
    value: {
      status: false,
      langMap: [],
      defaultLangMap: [CropInformationDefaultDataSetDisease],
    },
  },
  reducers: {
    //create first data item
    updateAllData: (state, action) => {
      state.value.status = true;
      state.value.langMap = action.payload;
    },
    //add empty language dataset
    addNewLangData: (state, action) => {
      state.value.status = true;
      const incomingPayload = action.payload;
      const newArray = [...state.value.langMap.langMap, incomingPayload];
      state.value.langMap.langMap = newArray;
    },
    //update individual items in localization array
    replaceIndex: (state, action) => {
      state.value.status = true;
      const newPayload = action.payload;
      const existingPayload = state.value.langMap.langMap;
      const newUpdateData = existingPayload.map((item) =>
        item.langCode === newPayload.langCode ? newPayload : item
      );
      state.value.langMap.langMap = newUpdateData;
    },
  },
});

export const { updateAllData, addNewLangData, replaceIndex } =
  update_Disease_Info.actions;

export default update_Disease_Info.reducer;
